export const blockIconsTransportationAirlinesNew = (
	<span className='material-symbols-outlined'>airlines</span>
);
